import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductsEditAllComponent } from './products-edit-all.component';

@Injectable({
  providedIn: 'root'
})
export class ProductsEditAllCanDeactivateGuard implements CanDeactivate<ProductsEditAllComponent> {
  canDeactivate(
    component: ProductsEditAllComponent
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate();
  }
}
